export type ReviewGender = 'male' | 'female' | 'other';

/** Unvan (Mr, Mrs, …) → API gender alanı */
export function mapHonorificToGender(honorific: string | null | undefined): ReviewGender | null {
    if (!honorific || !honorific.trim()) {
        return null;
    }
    const v = honorific.trim().toLowerCase();
    if (v === 'male' || v === 'female' || v === 'other') {
        return v;
    }
    if (['mr', 'mister', 'dr', 'prof', 'sir'].includes(v)) {
        return 'male';
    }
    if (['mrs', 'ms', 'miss', 'madam'].includes(v)) {
        return 'female';
    }
    return 'other';
}

export function resolveReviewApiMessage(
    payload: { message?: string; message_key?: string; error?: string; errors?: Record<string, string[] | string> },
    t: (key: string, fallback?: string) => string,
): string {
    if (payload.message_key) {
        return t(payload.message_key, payload.message ?? '');
    }
    if (payload.error) {
        const fromErrorKey = t(payload.error, payload.message ?? '');
        if (fromErrorKey) {
            return fromErrorKey;
        }
        if (payload.error.includes(' ') || payload.error.length > 64) {
            return payload.error;
        }
    }
    if (payload.errors) {
        for (const field of Object.keys(payload.errors)) {
            const raw = payload.errors[field];
            const first = Array.isArray(raw) ? raw[0] : raw;
            if (!first) continue;
            const fieldKey =
                field === 'gender'
                    ? 'review_form.error.gender_invalid'
                    : field === 'guest_email' || field === 'email'
                      ? 'review_form.error.email_invalid'
                      : field === 'name'
                        ? 'review_form.error.full_name_required'
                        : field === 'comment' || field === 'description'
                          ? 'review_form.error.review_required'
                          : `review_form.error.${field}_invalid`;
            const translated = t(fieldKey, String(first));
            if (translated) {
                return translated;
            }
        }
    }
    if (payload.message) {
        const maybeKey = t(payload.message, payload.message);
        return maybeKey;
    }
    return t('review_form.error.review_creation_failed', 'Review could not be created');
}
